import { useTranslation } from "react-i18next";

// The verbatim passages a source was cited for, under both engines' source sheets.
export function CitedPassages({
  quotes,
}: {
  quotes: readonly string[];
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <span className="text-caption font-semibold text-ds-slate-600">
        {t("Cited passages")}
      </span>
      {quotes.map((quote, index) => (
        <blockquote
          key={index}
          className="border-l-2 border-ds-mint-300 pl-3 text-footnote/relaxed italic text-ds-slate-700"
        >
          {quote}
        </blockquote>
      ))}
    </div>
  );
}
